
import { mapActions, mapGetters, mapState } from "vuex";
import { validationMixin } from "vuelidate";
import {
  SistemaMixin,
  ValidacaoMixin,
  EmitenteMixin,
  PessoaMixin,
} from "@/modules/Application";
import { mask } from "vue-the-mask";
import VueSelect from "vue-select";
import "vue-select/dist/vue-select.css";
import _ from "lodash";

export default {
  name: "app-link-prospect",
  mixins: [
    validationMixin,
    SistemaMixin,
    ValidacaoMixin,
    EmitenteMixin,
    PessoaMixin,
  ],
  directives: {
    mask,
  },
  components: {
    VueSelect,
  },
  data() {
    return {
      form: {},
      anexo_1: null,
      anexo_2: null,
      anexo_3: null,
      emissor: null,
      statusClient: null,
      observacao: null,
      windowWidth: window.innerWidth,
      clientes: [],
      valueCliente: null,
      statusSelecinado: null,
      negocioSelecinado: null,
      negocios: [
        {
          id: 1,
          descricao: "Prospecção",
        },
        {
          id: 2,
          descricao: "Venda",
        },
        {
          id: 3,
          descricao: "Agendamento",
        },
      ],
      status: [
        {
          id: 1,
          descricao: "Novo Cliente",
        },
        {
          id: 2,
          descricao: "Cliente Ativo",
        },
      ],
      localizacao: {},
    };
  },
  watch: {},
  computed: {
    ...mapGetters(["pageTitle", "layoutConfig"]),
    ...mapState({
      currentUser: (state) => state.auth.user,
    }),
    isMobile() {
      return this.windowWidth < 569;
    },
    cardStyle() {
      return {
        width: this.isMobile ? "94vw" : "",
      };
    },
  },
  methods: {
    ...mapActions(["setLoading"]),
    onResize() {
      this.windowWidth = window.innerWidth;
    },
    async getInit() {
      const data = await this.getDadosEmissor();
      if (data) {
        this.emissor = data;
      }
      this.getLocation();
    },
    async setAnexo(event, anexo) {
      const data = await event.target.files[0];
      const url = URL.createObjectURL(data);
      this[anexo] = url;
      this.form[anexo] = data;
    },
    onSearchCliente(search, loading) {
      if (search.length) {
        loading(true);
        this.searchClient(loading, search, this);
      }
    },
    searchClient: _.debounce(async (loading, search, vm) => {
      vm.clientes = await vm.getPessoaNome(search);
      loading(false);
    }, 350),
    async handleSendResponse() {
      this.addLoadingToButton("submit");
      if (!this.valueCliente) {
        this.$toast.error("Informe o status do orçamento!");
        this.removeLoadingToButton("submit");
        return;
      }
    },
    async onSubmit() {
      const submitButton = this.$refs["submit_prospect_novo"];

      if (!this.valueCliente) {
        this.$toast.error("Informe o cliente!");
        submitButton.removeAttribute("disabled", "");
        return;
      }

      if (!this.negocioSelecinado) {
        this.$toast.error("Selecione a forma de negócio!");
        submitButton.removeAttribute("disabled", "");
        return;
      }

      try {
        submitButton.classList.add("spinner", "spinner-light", "spinner-right");
        submitButton.setAttribute("disabled", "");

        let prospect = new FormData();
        prospect.append("contato", this.form.contato);
        prospect.append("responsavel", this.form.responsavel);
        prospect.append("observacao", this.form.observacao);
        prospect.append("status", 1);
        prospect.append("id_usuario", this.currentUser.id_usuario);

        if (this.valueCliente) {
          prospect.append("id_pessoa", this.valueCliente.id_pessoa);
        }

        if (this.negocioSelecinado) {
          prospect.append("negocio", this.negocioSelecinado);
        }

        if (this.localizacao) {
          prospect.append("latitude", this.localizacao.latitude);
          prospect.append("longitude", this.localizacao.longitude);
        }

        if (this.form.anexo_1) {
          prospect.append("anexo_1", this.form.anexo_1);
        }

        if (this.form.anexo_2) {
          prospect.append("anexo_2", this.form.anexo_2);
        }

        if (this.form.anexo_3) {
          prospect.append("anexo_3", this.form.anexo_3);
        }

        await this.$http.post("prospect/create", prospect);

        this.$toast.success("Atendimento gravado com sucesso!");
        submitButton.classList.remove(
          "spinner",
          "spinner-light",
          "spinner-right"
        );
        submitButton.removeAttribute("disabled", "");
        this.clearForm();
      } catch (error) {
        submitButton.classList.remove(
          "spinner",
          "spinner-light",
          "spinner-right"
        );
        submitButton.removeAttribute("disabled", "");
      }
    },
    setCliente(cliente) {
      this.valueCliente = cliente;
    },
    clearForm() {
      this.form = {};
      this.statusSelecinado = null;
      this.negocioSelecinado = null;
      this.valueCliente = null;
    },
    getLocation() {
      navigator.geolocation.getCurrentPosition(
        (success) => {
          this.localizacao.latitude = success.coords.latitude;
          this.localizacao.longitude = success.coords.longitude;
        },
        (failure) => {
          if (failure.message.startsWith("Only secure origins are allowed")) {
            this.$toast.error("Habilite a localização do seu navegador!");
          }
        }
      );
    },
  },
  async mounted() {
    this.setLoading(true);
    this.$nextTick(() => {
      window.addEventListener("resize", this.onResize);
    });
    await this.getInit();
    this.setLoading(false);
  },
  created() {},
};
